import { useEffect, useState } from "react";

export const InteresSelect = ({
  name,
  value,
  onChange,
}) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-interes"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="ER">Esperando respuesta</option>
      <option value="RL">Respuesta escrita</option>
      <option value="CI">Clientes con interes</option>
      <option value="SI">Clientes sin interes</option>
    </select>
  );
};
